import { createSlice } from "@reduxjs/toolkit";

export const customercountrySlice = createSlice({
  name: "customercountry",
  initialState: {
    value: "",
    list: [],
    valueProvince: "",
    listProvince: [],
    countryName:""
  },
  reducers: {
    clear: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = "";
    },
    clearProvince: (state) => {
      state.valueProvince = "";
    },
    set: (state, action) => {
      state.value = action.payload;
    },
    setProvince: (state, action) => {
      state.valueProvince = action.payload;
    },
    setCountryName: (state, action) => {
      state.countryName = action.payload;
    },
    initialList: (state, action) => {
      state.list = action.payload;
    },
    initialListProvince: (state, action) => {
      state.listProvince = action.payload;
    },
  },
});

export const {
  clear,
  set,
  initialList,
  clearProvince,
  setProvince,
  initialListProvince,
  setCountryName,
} = customercountrySlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectcustomerProvince = (state) =>
  state.customercountry.valueProvince;
export const getListofProvince = (state) => state.customercountry.listProvince;
export const selectcustomerCountry = (state) => state.customercountry.value;
export const selectCountryName = (state)=> state.customercountry.countryName;
export const getListofcustomerCountry = (state) => state.customercountry.list;
export default customercountrySlice.reducer;
